<template>
  <v-container class="fill-height" fluid>
    <v-row justify="center" align="center">
      <v-card width="400" @keyup.enter="login" tabindex="0">
        <v-card-title class="primary white--text">Please login</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field label="Username" v-model="username"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                label="Password"
                type="password"
                v-model="password"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert type="error" :value="badLogin"
                >Username and password not matching</v-alert
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :loading="loading" class="mb-4 mr-4" @click="login"
            >Login</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'login',

  data() {
    return {
      username: '',
      password: '',
      badLogin: false,
      loading: false
    }
  },

  methods: {
    login() {
      this.badLogin = false
      this.loading = true

      this.$auth
        .login({
          data: { username: this.username, password: this.password }
        })
        .then(
          () => {
            this.loading = false
          },
          () => {
            this.badLogin = true
            this.loading = false
          }
        )
    }
  }
}
</script>
